import {
  Box,
  Button,
  Collapse,
  IconButton,
  icons,
  Stack,
  TextField,
  theme,
} from "@hiver/hiver-ui-kit";
import { useState } from "react";

const styles = {
  container: {
    borderRadius: "2px",
    padding: "12px 16px",
    backgroundColor: "gray.background",
    position: "relative",
    "& #prompt-editor-edit-button": {
      display: "none",
    },
    "&:hover #prompt-editor-edit-button": {
      display: "block",
      marginLeft: "auto",
      position: "absolute",
      right: "8px",
      top: "2px",
      padding: "0 8px",
      "& svg": {
        height: "20px",
        width: "20px",
      },
    },
  },
  textField: {
    backgroundColor: "transparent",
    "& .MuiInput-input, & .MuiInput-root": {
      padding: 0,
    },
    "& .MuiFormHelperText-root": {
      margin: 0,
    },
  },
};

export const PromptEditor = ({
  prompt = "",
  onPromtUpdate,
  disabled = false,
  focused = false,
  setFocused,
}) => {
  const [value, setValue] = useState(prompt);

  const handleCancel = () => {
    handleFocus(false);
    setValue(prompt);
  };

  const handleUpdate = () => {
    const trimmedValue = value?.trim() || "";
    handleFocus(false);
    onPromtUpdate(trimmedValue);
    setValue(trimmedValue);
  };

  const handleFocus = (value) => {
    setFocused(value);
  };

  return (
    <Box
      sx={{
        ...styles.container,
        border: `1px solid ${
          focused ? theme.palette.blue.primary : theme.palette.gray.gray5
        }`,
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? "none" : "auto",
      }}
    >
      <TextField
        fullWidth
        multiline
        variant="standard"
        value={value}
        onFocus={() => handleFocus(true)}
        onChange={(e) => setValue(e.target.value)}
        InputProps={{
          disableUnderline: true,
        }}
        inputProps={{ maxLength: 1000 }}
        sx={styles.textField}
      />
      {!focused && (
        <IconButton
          id="prompt-editor-edit-button"
          onClick={() => handleFocus(true)}
        >
          <icons.EditOutlined />
        </IconButton>
      )}
      <Collapse in={focused}>
        <Stack direction="row" spacing={2} sx={{ mt: 4 }}>
          <Button
            color="tertiary"
            size="medium"
            onClick={handleUpdate}
            disabled={!value?.trim() || value === prompt}
          >
            Update Prompt
          </Button>
          <Button
            variant="text"
            color="tertiary"
            size="medium"
            onClick={handleCancel}
          >
            Cancel
          </Button>
        </Stack>
      </Collapse>
    </Box>
  );
};
